import type { ResponsivePhoto } from "./media";

// Imported rather than referenced by path so Vite fingerprints the filenames.
// The CDN in front of this site only serves a long cache lifetime for
// content-hashed assets; anything on a stable path comes back with no
// `Cache-Control` header at all.
import pw480 from "@/assets/images/service-power-washing-480.webp";
import pw640 from "@/assets/images/service-power-washing-640.webp";
import pw768 from "@/assets/images/service-power-washing-768.webp";
import pw960 from "@/assets/images/service-power-washing-960.webp";
import pw1280 from "@/assets/images/service-power-washing-1280.webp";
import pwOg from "@/assets/images/service-power-washing-1280.jpg";

import rg480 from "@/assets/images/service-rain-gutters-480.webp";
import rg640 from "@/assets/images/service-rain-gutters-640.webp";
import rg768 from "@/assets/images/service-rain-gutters-768.webp";
import rg960 from "@/assets/images/service-rain-gutters-960.webp";
import rg1280 from "@/assets/images/service-rain-gutters-1280.webp";
import rgOg from "@/assets/images/service-rain-gutters-1280.jpg";

const set = (steps: [string, number][]): ResponsivePhoto => ({
  src: steps[steps.length - 1][0],
  srcSet: steps.map(([url, w]) => `${url} ${w}w`).join(", "),
  width: 1280,
  height: 960,
});

/** Licensed stock photography for the two services with no client photo. */
export const stockPhotos: Record<string, ResponsivePhoto> = {
  "power-washing": set([
    [pw480, 480],
    [pw640, 640],
    [pw768, 768],
    [pw960, 960],
    [pw1280, 1280],
  ]),
  "rain-gutter-installation": set([
    [rg480, 480],
    [rg640, 640],
    [rg768, 768],
    [rg960, 960],
    [rg1280, 1280],
  ]),
};

/** JPEG variants, for Open Graph. */
export const stockOgPhotos: Record<string, string> = {
  "power-washing": pwOg,
  "rain-gutter-installation": rgOg,
};
